/**
 * Firestore document / collection path segments cannot contain `/`.
 * Passing a download URL (`https://…`) or a storage path creates empty
 * segments (`//`) and throws synchronously from `doc()` / `collection()`.
 *
 * Comment attachments historically used the download URL as `documentId`;
 * purchasing attachments use `purchase:{prId}:{storagePath}` which may also
 * contain `/`. Only use those values as field equality filters — never as
 * path segments unless this helper says they are safe.
 */
export function canUseAsFirestoreDocId(id: string | null | undefined): boolean {
  const s = (id ?? '').trim();
  return s.length > 0 && !s.includes('/');
}

/**
 * Prefer a stable slash-free attachment id for PDF/image viewers so presence
 * lookups and `projectFiles` reads never receive a download URL. Fall back to
 * the URL when no safe id exists (annotations still match via `documentUrl`).
 */
export function viewerDocumentIdForAttachment(att: {
  id?: string | null;
  url?: string | null;
}): string {
  const id = (att.id ?? '').trim();
  if (canUseAsFirestoreDocId(id)) return id;
  return (att.url ?? '').trim();
}
